/**
 * חותמת זמן כפי שהממשק צריך אותה: כל דבר עם toDate().
 * Timestamp של Firebase עומד בזה, וכך גם חותמות הזמן של מצב התצוגה.
 */
export interface Ts {
  toDate(): Date;
}

export function tsToDate(v: unknown): Date | null {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (typeof v === 'object' && v !== null && 'toDate' in v && typeof (v as Ts).toDate === 'function') return (v as Ts).toDate();
  return null;
}

export function dateToTs(d: Date): Ts {
  return { toDate: () => d };
}
